/**
 * @module Header-Nav-Menus
 */

import React from 'react';
import { NavLink, useLocation } from "react-router-dom";
import { route } from "../../../../globals/constants";
import { navUrl } from "../../../../globals/common-functions";
import './nav-menu.scss';

/**
 * 
 * @returns Navigation Menus for header section
 */
const SectionHeaderNavMenu: React.FC = () => {
    const location = useLocation();
    const isServicesActive = location.pathname.startsWith(route.services.INITIAL);
    const isBlogActive = location.pathname.startsWith('/blog');

    return (
        <ul className="nav navbar-nav">
            <li>
                <NavLink 
                    to={route.INITIAL} 
                    className={({ isActive }) => isActive ? 'active' : ''}
                >
                    Home
                </NavLink>
            </li>
            <li className="has-child">
                <a href="!#" style={{ pointerEvents: "none", cursor: "default" }} className={isServicesActive ? 'active' : ''}>Services</a>
                <ul className="sub-menu">
                    <li>
                        <NavLink 
                            to={navUrl.services(route.services.IT_CONSULTANCY)} 
                            className={({ isActive }) => isActive ? 'active' : ''}
                        >
                            IT Consultancy
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to={navUrl.services(route.services.CUSTOM_SOFTWARE)} 
                            className={({ isActive }) => isActive ? 'active' : ''}
                        >
                            Custom Software
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to={navUrl.services(route.services.MOBILE_DEVELOPMENT)} 
                            className={({ isActive }) => isActive ? 'active' : ''}
                        >
                            Mobile & Web Apps
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to={navUrl.services(route.services.PAYMENT_GATEWAY)} 
                            className={({ isActive }) => isActive ? 'active' : ''}
                        >
                            Payment Solutions
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to={navUrl.services(route.services.IT_SECURITY)} 
                            className={({ isActive }) => isActive ? 'active' : ''}
                        >
                            Security & Training
                        </NavLink>
                    </li>
                </ul>
            </li>
            <li>
                <NavLink 
                    to={navUrl.pages(route.pages.CASE_STUDY)} 
                    className={({ isActive }) => isActive ? 'active' : ''}
                >
                    Success Stories
                </NavLink>
            </li>
            <li>
                <NavLink 
                    to={navUrl.pages(route.pages.ABOUT)} 
                    className={({ isActive }) => isActive ? 'active' : ''}
                >
                    About
                </NavLink>
            </li>
            <li>
                <NavLink 
                    to={navUrl.blogs(route.blogs.BLOGS)} 
                    className={({ isActive }) => (isActive || isBlogActive) ? 'active' : ''}
                >
                    Blog
                </NavLink>
            </li>
        </ul>
    );
};

export default SectionHeaderNavMenu;